import "./styles.css";
import "./revenue-landing.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import GastroPage from "./GastroPage";
import BuilderPage from "./BuilderPage";
import TemplatesPage from "./TemplatesPage";
import PedikuraPage from "./PedikuraPage";
import OnyxoBusinessChat from "./OnyxoBusinessChat";
import VizitkaPage from "./VizitkaPage";

const path = window.location.pathname;
const Root = path === "/sluzby" || path === "/sluzby/" || path === "/vizitka" || path === "/vizitka/" ? VizitkaPage : path === "/pedikura-pardubice" || path === "/pedikura-pardubice/" ? PedikuraPage : path === "/sablony" || path === "/sablony/" ? TemplatesPage : path.startsWith("/builder") ? BuilderPage : path.startsWith("/gastro") ? GastroPage : App;

if (Root === GastroPage || Root === BuilderPage) {
  const isGastro = Root === GastroPage;
  const title = isGastro ? "ONYXGASTRO+ | Web, QR menu a chytrý gastro provoz" : "ONYXWEBbuilder+ | Weby, landing pages a digitální řešení";
  const description = isGastro
    ? "ONYXGASTRO+ spojuje web ONYXWEB, QR menu, rezervace a objednávky podle potřeb provozu. Nezávazná poptávka ve 3 krocích."
    : "ONYXWEBbuilder+ — vyberte řešení pro nový web, prodejní stránku nebo automatizaci. Nezávazně poptejte návrh realizace.";
  const url = isGastro ? "https://onyxweb.cz/gastro" : "https://onyxweb.cz/builder";
  document.title = title;
  document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  document.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
  document.querySelector('meta[property="og:title"]')?.setAttribute("content", title);
  document.querySelector('meta[property="og:description"]')?.setAttribute("content", description);
  document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
}

if (Root === VizitkaPage) {
  document.title = "ONYXWEB Vizitka+ | Od 249 Kč měsíčně, roční platba";
  document.querySelector('link[rel="canonical"]')?.setAttribute("href", "https://onyxweb.cz/vizitka");
}

if (Root === PedikuraPage) {
  const title = "Pedikúra Dita | Pedikúra Pardubice–Studánka | Telefonické objednávky";
  const description = "Pedikúra Dita Gürtlerová, Blahoutova 623, Pardubice. Lázeň nohou, ošetření tvrdé kůže, péče o nehty a masáže. Objednání na 723 225 935.";
  const url = "https://onyxweb.cz/pedikura-pardubice";
  document.title = title;
  document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  document.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
  document.querySelector('meta[property="og:title"]')?.setAttribute("content", title);
  document.querySelector('meta[property="og:description"]')?.setAttribute("content", description);
  document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
  document.querySelector('meta[property="og:image"]')?.setAttribute("content", "https://onyxweb.cz/pedikura/og-dita.jpg");

}
if (Root === TemplatesPage) {
  document.title = "Šablony a designové směry | ONYXWEB | OPTIMATEO";
  document.querySelector('link[rel="canonical"]')?.setAttribute("href", "https://onyxweb.cz/sablony");
  document.querySelector('meta[property="og:url"]')?.setAttribute("content", "https://onyxweb.cz/sablony");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
    {Root !== PedikuraPage && <OnyxoBusinessChat mode="onyxweb" />}
  </StrictMode>
);
